import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || null,
    bgVideo: searchParams.get('bgVideo') || '1',
    bgPoster: searchParams.get('bgPoster') || null,
    title: getDefaultValue(
      searchParams.get('title'),
      'Присылайте свой вариант'
    ),
    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),
    titleFontSize: searchParams.get('titleFontSize') || '3.125',
    sizeQR: searchParams.get('sizeQR') || '22.9',
    questionFontSize: searchParams.get('questionFontSize') || '4.22',
    answerFontSize: searchParams.get('answerFontSize') || '4',
    varNumFontSize: searchParams.get('varNumFontSize') || '5.86',

    paddingQR: searchParams.get('paddingQR') || '0',
    // phoneNumber,
    // phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || '4.8',
    // socials: searchParams.get('socials'),
  };
};
